export const PALETTE_HEX = ['#000000', '#D3DBE6', '#1D2B53', '#7E2553', '#008751', '#FF004D', '#FFA300', '#29ADFF'];

// Oud wit hoort nu bij plek 2, zodat krabbels van vroeger niet zwart worden.
export const paletteIndexOf = (hex) => {
  const u = String(hex).toUpperCase();
  const i = PALETTE_HEX.indexOf(u);
  return i >= 0 ? i : (u === '#FFFFFF' ? 1 : -1);
};

// De acht palet-kleuren als rgb, om een geplakt plaatje mee om te rekenen.
export const PALETTE_RGB = PALETTE_HEX.map((h) => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]);

export function nearestPalette(r, g, b) {
  // Het oog weegt groen zwaarder dan blauw; die weging geeft een betere gok
  // dan de kale afstand tussen twee kleuren.
  let best = 0, bd = Infinity;
  for (let i = 0; i < PALETTE_RGB.length; i++) {
    const p = PALETTE_RGB[i];
    const dr = r - p[0], dg = g - p[1], db = b - p[2];
    const d = 2 * dr * dr + 4 * dg * dg + 3 * db * db;
    if (d < bd) { bd = d; best = i; }
  }
  return best;
}
